import { NgModule } from '@angular/core';

import { AccountMasterDataModule } from '@mysvg/api/account-master-data/account-master-data.module';
import { AuthModule } from '@mysvg/api/auth/auth.module';
import { BlobDocumentModule } from '@mysvg/api/blob-document/blob-document.module';
import { BpmModule } from '@mysvg/api/bpm/bpm.module';
import { ContactDataModule } from '@mysvg/api/contact-data/contact-data.module';
import { CustomerPropertiesModule } from '@mysvg/api/customer-properties/customer-properties.module';
import { CustomerReadModelModule } from '@mysvg/api/customer/customer-read-model.module';
import { DashboardConfigModule } from '@mysvg/api/dashboard-config/dashboard-config.module';
import { DhlAddressesModule } from '@mysvg/api/dhl-addresses/dhl-addresses.module';
import { DirectDebitReturnModule } from '@mysvg/api/direct-debit-return/direct-debit-return.module';
import { DkvBrokerModule } from '@mysvg/api/dkv-broker/dkv-broker.module';
import { DocumentGeneratorModule } from '@mysvg/api/document-generator/document-generator.module';
import { DocumentMigrationModule } from '@mysvg/api/document-migration/document-migration.module';
import { DocumentModule } from '@mysvg/api/document/document.module';
import { FinancialGuaranteesModule } from '@mysvg/api/financial-guarantees/financial-guarantees.module';
import { FuelCardComposerModule } from '@mysvg/api/fuel-card-composer/fuel-card-composer.module';
import { FuelCardShellListPricesModule } from '@mysvg/api/fuel-card-shell-list-prices/fuel-card-shell-list-prices.module';
import { FuelCardModule } from '@mysvg/api/fuel-card/fuel-card.module';
import { KmasterBoxManagementModule } from '@mysvg/api/kmaster-box-management/kmaster-box-management.module';
import { LegacyReportsModule } from '@mysvg/api/legacy-reports/legacy-reports.module';
import { MailModule } from '@mysvg/api/mail/mail.module';
import { MessagingModule } from '@mysvg/api/messaging/messaging.module';
import { OperationFiguresModule } from '@mysvg/api/operation-figures/operation-figures.module';
import { PaymentModule } from '@mysvg/api/payment/payment.module';
import { PdiDkvApiModule } from '@mysvg/api/pdi-dkv-api/pdi-dkv-api.module';
import { PiaModule } from '@mysvg/api/pia/pia.module';
import { SvgsModule } from '@mysvg/api/svgs/svgs.module';
import { SVGZAPICoreModule } from '@mysvg/api/svgzapi-core/svgzapi-core.module';
import { TollBoxModule } from '@mysvg/api/toll-box/toll-box.module';
import { TollCollectModule } from '@mysvg/api/toll-collect/toll-collect.module';
import { TollComposerModule } from '@mysvg/api/toll-composer/toll-composer.module';
import { VehicleModule } from '@mysvg/api/vehicle/vehicle.module';
import { VignetteModule } from '@mysvg/api/vignette/vignette.module';
import { ExcelModule } from '@z-service/api/excel/excel.module';
import { JournalModule } from '@z-service/api/journal/journal.module';
import { ReleaseNotesModule } from '@z-service/api/release-notes/release-notes.module';

import { API_BASE_URLS } from '../environments/api-base-urls';

@NgModule({
	imports: [
		AccountMasterDataModule.forRoot({ rootUrl: API_BASE_URLS.accountMasterData }),
		AuthModule.forRoot({ rootUrl: API_BASE_URLS.auth }),
		BlobDocumentModule.forRoot({ rootUrl: API_BASE_URLS.blobDocument }),
		BpmModule.forRoot({ rootUrl: API_BASE_URLS.bpm }),
		ContactDataModule.forRoot({ rootUrl: API_BASE_URLS.contactData }),
		CustomerPropertiesModule.forRoot({ rootUrl: API_BASE_URLS.customerProperties }),
		CustomerReadModelModule.forRoot({ rootUrl: API_BASE_URLS.customer }),
		DashboardConfigModule.forRoot({ rootUrl: API_BASE_URLS.dashboardConfig }),
		DirectDebitReturnModule.forRoot({ rootUrl: API_BASE_URLS.directDebitReturn }),
		DhlAddressesModule.forRoot({ rootUrl: API_BASE_URLS.dhlAddresses }),
		DkvBrokerModule.forRoot({ rootUrl: API_BASE_URLS.dkvBroker }),
		DocumentGeneratorModule.forRoot({ rootUrl: API_BASE_URLS.documentGenerator }),
		DocumentMigrationModule.forRoot({ rootUrl: API_BASE_URLS.documentMigration }),
		DocumentModule.forRoot({ rootUrl: API_BASE_URLS.document }),
		ExcelModule.forRoot({ rootUrl: API_BASE_URLS.excel }),
		FinancialGuaranteesModule.forRoot({ rootUrl: API_BASE_URLS.financialGuarantees }),
		FuelCardComposerModule.forRoot({ rootUrl: API_BASE_URLS.fuelCardComposer }),
		FuelCardModule.forRoot({ rootUrl: API_BASE_URLS.fuelCard }),
		FuelCardShellListPricesModule.forRoot({ rootUrl: API_BASE_URLS.fuelCardShellListPrices }),
		JournalModule.forRoot({ rootUrl: API_BASE_URLS.journal }),
		LegacyReportsModule.forRoot({ rootUrl: API_BASE_URLS.legacyReports }),
		KmasterBoxManagementModule.forRoot({ rootUrl: API_BASE_URLS.kmasterBoxManagement }),
		MailModule.forRoot({ rootUrl: API_BASE_URLS.mail }),
		MessagingModule.forRoot({ rootUrl: API_BASE_URLS.messaging }),
		OperationFiguresModule.forRoot({ rootUrl: API_BASE_URLS.operationFigures }),
		PaymentModule.forRoot({ rootUrl: API_BASE_URLS.payment }),
		PdiDkvApiModule.forRoot({ rootUrl: API_BASE_URLS.pdiDkvApi }),
		PiaModule.forRoot({ rootUrl: API_BASE_URLS.pia }),
		ReleaseNotesModule.forRoot({ rootUrl: API_BASE_URLS.releaseNotes }),
		SVGZAPICoreModule.forRoot({ rootUrl: API_BASE_URLS.svgzapiCore }),
		SvgsModule.forRoot({ rootUrl: API_BASE_URLS.svgs }),
		TollBoxModule.forRoot({ rootUrl: API_BASE_URLS.tollBox }),
		TollCollectModule.forRoot({ rootUrl: API_BASE_URLS.tollCollect }),
		TollComposerModule.forRoot({ rootUrl: API_BASE_URLS.toll }),
		VehicleModule.forRoot({ rootUrl: API_BASE_URLS.vehicle }),
		VignetteModule.forRoot({ rootUrl: API_BASE_URLS.vignette }),
	],
})
export class ApiModule {}
